/**
 * @flow
 * @relayHash 911b6f7c963d4b4ee7e7ee3fbfc77f97
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type ChangeCurrencyMutationVariables = {|
  input: {
    userServiceId: string;
    firstName?: ?string;
    lastName?: ?string;
    email?: ?string;
    currency?: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
    measurementUnit?: ?"CM" | "IN";
    zipCode?: ?string;
    clientMutationId?: ?string;
  };
|};
export type ChangeCurrencyMutationResponse = {|
  +editPersonalProfile: ?{|
    +user: ?{|
      +profile: ?{|
        +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
      |};
    |};
  |};
|};
*/


/*
mutation ChangeCurrencyMutation(
  $input: EditPersonalProfileInput!
) {
  editPersonalProfile(input: $input) {
    user {
      profile {
        currency
      }
      id
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "EditPersonalProfileInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangeCurrencyMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "EditPersonalProfileInput!"
          }
        ],
        "concreteType": "EditPersonalProfilePayload",
        "name": "editPersonalProfile",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "User",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Profile",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "currency",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "ChangeCurrencyMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "EditPersonalProfileInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "ChangeCurrencyMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "EditPersonalProfileInput!"
          }
        ],
        "concreteType": "EditPersonalProfilePayload",
        "name": "editPersonalProfile",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "User",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Profile",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "currency",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation ChangeCurrencyMutation(\n  $input: EditPersonalProfileInput!\n) {\n  editPersonalProfile(input: $input) {\n    user {\n      profile {\n        currency\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/components/Footer/CurrencySelector/__generated__/ChangeCurrencyMutation.graphql.js